// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateThemePreferredTheme = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            preferredTheme: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_THEME_PREFERRED_THEME
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/theme-settings.js